import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import React from 'react';
import { getProductTypeLabel, getFundsCategoriesPath } from '@finect/front-resources/Products';
import { useTheme } from 'styled-components';
import { Section } from '../../Section';
import { Category } from '../../Products/Categories';
export var ManagementCompanyCategories = function ManagementCompanyCategories(_ref) {
  var productType = _ref.productType,
    managementCompany = _ref.managementCompany;
  var categories = managementCompany.categories ? managementCompany.categories : [];
  var theme = useTheme();
  return React.createElement(Section, {
    title: "Categor\xEDas donde invierte",
    subtitle: "".concat(managementCompany.name, " invierte en ").concat(categories.length, " categor\xEDas a trav\xE9s de ").concat(managementCompany.stats ? managementCompany.stats.funds : 'sus', " ").concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase')),
    link: {
      text: "Ver m\xE1s categor\xEDas de ".concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase')),
      href: getFundsCategoriesPath(theme, productType)
    }
  }, React.createElement("div", null, categories.slice(0, 10).map(function (category) {
    return React.createElement(Category, {
      key: category.id,
      category: category,
      productType: productType
    });
  })));
};